import React, { useEffect, useState } from 'react'
import './App.css';
import { generateMerkleProof } from './whitelist/merkle-tree'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'



function App() {

	const [feedback, setFeedback] = useState(``)

	const [CONFIG, SET_CONFIG] = useState({
		NFTNAME: "SNOW",
		SCAN: "https://etherscan.io"
	})

	const getConfig = async () => {
		const configResponse = await fetch('/config/config.json', {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		})
		const config = await configResponse.json()
		SET_CONFIG(config)
	}

	useEffect(() => {
		getConfig()
	}, [])

	const genProof = () =>{
		var address = document.getElementById("address").value;
		const merkleProof = generateMerkleProof(address).toString();
		console.log (merkleProof)
		if(merkleProof.length < 1){
			setFeedback(`You are not whitelisted!`)
		}
		else{
			navigator.clipboard.writeText(merkleProof);
			setFeedback(`Copied!`)
		}
	}

	return (
		<div className="App">


			<div className="Modal">
				<div className="w-full lg:w-1/3 mx-auto relative p-5">
					<div className="grid grid-cols-1 lg:grid-cols-1 gap-12 bg-gradient-to-r from-cyan-500 to-blue-500 p-10 lg:p-[60px] rounded-2xl">
						<div>
							<img src={'/images/example.gif'}></img> <br></br>
							<h3 className="text-white text-3xl font-semibold">Get Your Merkle Proof!</h3>

							<p className="text-xl text-white mt-4">
								Anyone can generate the proof using any public address in the list, but <strong>only the owner of that address</strong> will be able to make a successful transaction by using it.
							</p>
							<br></br>
							<p className="text-white mt-1 text-sm">
									<strong>{feedback}</strong>
							</p>
							<div className="flex items-stretch">
								<input
								    name="address"
									id="address"
									type="string"
									placeholder="0x0000...."
									className="px-4 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
								/>
								

								<button className="bg-blue-500 hover:bg-blue-600 text-white py-3 px-5 rounded-lg font-semibold ml-4 border-2 border-white"
								onClick={(e) => {
								
									genProof()
								  }}
								>
									Copy
								</button>
							</div>
							<p className="text-white mt-2 text-sm">
								You can interact with the smart-contract <strong>directly</strong> through <a href={CONFIG.SCAN} className="underline">Etherscan</a>, without even connecting your wallet to this App!
							</p>
							<br></br>
							<footer>
								<a className="text-white mt-1 text-sm" href='https://linktr.ee/reservedsnow'>

									2022 all rights reserved <strong>{CONFIG.NFTNAME}</strong> <br></br>
									Created with <FontAwesomeIcon icon={faHeart} /> by <strong>SnowStudios</strong>
								</a>
							</footer>
						</div>


					</div>
				</div>
			</div>



		</div>
	);
}

export default App;
